import {createContext as $jFTsb$createContext, useContext as $jFTsb$useContext} from "react";
import {StatefulComponent as $jFTsb$StatefulComponent} from "@macrostrat/ui-components";
import $jFTsb$macrostrathyper from "@macrostrat/hyper";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;



var $c9720339cdc6092c$exports = {};

$c9720339cdc6092c$exports = (parcelRequire("daZiC")).getBundleURL('jFTsb') + "utils.5eb13014.js";


var $9f001124e7de8531$exports = {};

$9f001124e7de8531$exports = (parcelRequire("daZiC")).getBundleURL('jFTsb') + "label-primitives.abcfa596.js";



var $aVUB5 = parcelRequire("aVUB5");
const $c86bb60129705c5e$export$20c7bffdb69233c9 = (0, $jFTsb$createContext)(null);
const $c86bb60129705c5e$var$buildColumnIndex = function() {
    /*
   * Find out where on the X axis arrows,
   * etc. should plot to aviod overlaps
   */ const heightTracker = [];
    return function(note) {
        let colIx = 0;
        // Get column that note should render in
        const nPossibleCols = heightTracker.length + 1;
        for(let column = 0, end = nPossibleCols, asc = 0 <= end; asc ? column <= end : column >= end; asc ? column++ : column--){
            if (heightTracker[column] == null) heightTracker[column] = note.height;
            if (heightTracker[column] < note.height) {
                const hy = note.top_height || note.height;
                heightTracker[column] = hy;
                colIx = column;
                break;
            }
        }
        return colIx;
    };
};
const $c86bb60129705c5e$var$withinDomain = (scale)=>function(d) {
        const [start, end] = scale.domain();
        // end height greater than beginning
        const end_height = d.top_height || d.height;
        if (start < end) // Normal scale (e.g. height)
        return end_height >= start && d.height <= end;
        else // Inverted scale (e.g. time)
        return end_height <= start && d.height >= end;
    };
class $c86bb60129705c5e$export$c48860e5e2301a05 extends (0, $jFTsb$StatefulComponent) {
    static #_ = this.contextType = (0, $aVUB5.ColumnContext);
    static #_2 = this.defaultProps = {
        paddingLeft: 60,
        estimatedTextHeight (note, width) {
            const txt = note.note || "";
            return 12;
        }
    };
    constructor(props){
        super(props);
        this.computeContextValue = this.computeContextValue.bind(this);
        this.savedRendererForWidth = this.savedRendererForWidth.bind(this);
        this.generatePath = this.generatePath.bind(this);
        this.createNodeForNote = this.createNodeForNote.bind(this);
        this.computeForceLayout = this.computeForceLayout.bind(this);
        this.registerHeight = this.registerHeight.bind(this);
        this.updateNotes = this.updateNotes.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.componentDidUpdate = this.componentDidUpdate.bind(this);
        // State is very minimal to start
        const { noteComponent: noteComponent } = this.props;
        this.state = {
            notes: [],
            elementHeights: {},
            columnIndex: {},
            nodes: {},
            generatePath: this.generatePath,
            createNodeForNote: this.createNodeForNote,
            noteComponent: noteComponent
        };
    }
    render() {
        const { children: children, width: width } = this.props;
        return (0, $jFTsb$macrostrathyper)($c86bb60129705c5e$export$20c7bffdb69233c9.Provider, {
            value: this.state
        }, (0, $jFTsb$macrostrathyper)((0, $aVUB5.ColumnLayoutProvider), {
            width: width
        }, children));
    }
    computeContextValue() {
        const { width: width, paddingLeft: paddingLeft } = this.props;
        // Clamp notes to within scale boundaries
        // (we could turn this off if desired)
        const { scaleClamped: scale } = this.context;
        const forwardedValues = {
            paddingLeft: // Forwarded values from column context
            // There may be a more elegant way to do this
            paddingLeft,
            scale: scale,
            width: width,
            registerHeight: this.registerHeight,
            generatePath: this.generatePath
        };
        // Compute force layout
        const renderer = new (0, $9f001124e7de8531$exports.Renderer)({
            direction: "right",
            layerGap: paddingLeft,
            nodeHeight: 5
        });
        return this.setState({
            renderer: renderer,
            ...forwardedValues
        });
    }
    savedRendererForWidth(width) {
        if (this._rendererIndex == null) this._rendererIndex = {};
        if (this._rendererIndex[width] == null) this._rendererIndex[width] = new (0, $9f001124e7de8531$exports.Renderer)({
            direction: "right",
            layerGap: width,
            nodeHeight: 5
        });
        return this._rendererIndex[width];
    }
    generatePath(node, pixelOffset) {
        const { paddingLeft: paddingLeft } = this.props;
        const renderer = this.savedRendererForWidth(paddingLeft - pixelOffset);
        try {
            return renderer.generatePath(node);
        } catch (err) {
            return null;
        }
    }
    createNodeForNote(note) {
        const { notes: notes, elementHeights: elementHeights } = this.state;
        let { scaleClamped: scale } = this.context;
        const { id: noteID } = note;
        const pixelHeight = elementHeights[noteID] || 10;
        const padding = 5;
        const lowerHeight = scale(note.height);
        if ((0, $c9720339cdc6092c$exports.hasSpan)(note)) {
            const upperHeight = scale(note.top_height);
            const harr = [
                lowerHeight - padding,
                upperHeight + padding
            ];
            if (harr[0] - harr[1] > 0) return new (0, $9f001124e7de8531$exports.FlexibleNode)(harr, pixelHeight);
        }
        return new (0, $9f001124e7de8531$exports.Node)(lowerHeight, pixelHeight);
    }
    computeForceLayout(prevProps, prevState) {
        let { notes: notes, nodes: nodes, elementHeights: elementHeights } = this.state;
        const { pixelHeight: pixelHeight } = this.context;
        const { width: width, paddingLeft: paddingLeft, forceOptions: forceOptions } = this.props;
        if (notes.length === 0) return;
        // Something is wrong...
        //return if elementHeights.length < notes.length
        // Return if we've already computed nodes
        const v1 = Object.keys(nodes).length === notes.length;
        if (prevState == null) prevState = {};
        const v2 = elementHeights === prevState.elementHeights || [];
        if (v1 && v2) return;
        const force = new (0, $9f001124e7de8531$exports.Force)({
            minPos: 0,
            maxPos: pixelHeight,
            nodeSpacing: 0,
            ...forceOptions
        });
        const dataNodes = notes.map(this.createNodeForNote);
        force.nodes(dataNodes).compute();
        const _nodes = force.nodes() ?? [];
        const nodesObj = {};
        for(let i = 0; i < _nodes.length; i++){
            const node = _nodes[i];
            const note = notes[i];
            nodesObj[note.id] = node;
        }
        return this.updateState({
            nodes: {
                $set: nodesObj
            }
        });
    }
    registerHeight(id, height) {
        if (height == null) return;
        const { elementHeights: elementHeights } = this.state;
        elementHeights[id] = height;
        return this.updateState({
            elementHeights: {
                $set: elementHeights
            }
        });
    }
    updateNotes() {
        // We received a new set of notes from props
        const { scaleClamped: scaleClamped } = this.context;
        const notes = this.props.notes.filter($c86bb60129705c5e$var$withinDomain(scaleClamped)).sort((a, b)=>a.height - b.height);
        const columnIndex = notes.map($c86bb60129705c5e$var$buildColumnIndex());
        return this.setState({
            notes: notes,
            columnIndex: columnIndex
        });
    }
    /*
   * Lifecycle methods
   */ componentDidMount() {
        this._previousContext = null;
        this.updateNotes();
        return this.computeContextValue();
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.notes !== prevProps.notes) this.updateNotes();
        // Update note component
        const { noteComponent: noteComponent } = this.props;
        if (noteComponent !== prevProps.noteComponent) this.setState({
            noteComponent: noteComponent
        });
        this.computeForceLayout.call(prevProps, prevState);
        if (this.props.notes === prevProps.notes) return;
        if (this.context === this._previousContext) return;
        this.computeContextValue();
        return this._previousContext = this.context;
    }
}
const $c86bb60129705c5e$export$b74b5a117fd60a1d = function(props) {
    let { padding: padding, width: width, ...rest } = props;
    if (padding == null) padding = 5;
    const { pixelHeight: pixelHeight } = (0, $jFTsb$useContext)((0, $aVUB5.ColumnContext));
    if (width == null) ({ width: width } = (0, $jFTsb$useContext)($c86bb60129705c5e$export$20c7bffdb69233c9));
    if (isNaN(width)) return null;
    return (0, $jFTsb$macrostrathyper)("rect", {
        width: width + 2 * padding,
        height: pixelHeight,
        transform: `translate(${-padding},${-padding})`,
        ...rest
    });
};
const $c86bb60129705c5e$export$53f13bca8c4c45d9 = function({ fill: fill, ...rest }) {
    if (fill == null) fill = "transparent";
    return (0, $jFTsb$macrostrathyper)($c86bb60129705c5e$export$b74b5a117fd60a1d, {
        className: "underlay",
        fill: fill,
        ...rest
    });
};


//# sourceMappingURL=layout.a0997bea.js.map
